import referralReducer from './reducer';

export function getReferralModule() {
  return {
    // Unique id of the module
    id: 'referral',
    // Maps the Store key to the reducer
    reducerMap: {
      referral: referralReducer,
    },
  };
}
